<template>
    <v-container>
        <div class="content">
            <div class="identity">
                <div class="container h-100">
                    <button
                            class="btn-close"
                            @click.prevent="[$store.commit('resetCarData'), $router.go(-1)]"
                    >
                        <span class="dingbat">&#x2716;</span>
                    </button>
                    <div class="row h-100 form-wrapper">
                        <div class="col-md-5 d-flex justify-content-end">
                            <div class="d-flex flex-column max-310 w-100">
                                <h1 class="mb-3">Новый клиент</h1>
                                <v-form ref="form" v-model="valid">
                                    <v-text-field
                                            v-async-validate:debounce="500"
                                            v-model="localPhone"
                                            :async-rules="$_rulesAs.phone"
                                            placeholder="Телефон"
                                            solo
                                            v-mask="'+7(###) ###-##-##'"
                                    />
                                    <v-text-field
                                            v-model="client.customer.name"
                                            :rules="[rules.required]"
                                            placeholder="Имя"
                                            solo
                                            :disabled="hasClient"
                                    />
                                    <v-text-field
                                            v-model="client.customer.surname"
                                            :rules="[rules.required]"
                                            placeholder="Фамилия"
                                            solo
                                            :disabled="hasClient"
                                    />

                                    <v-text-field
                                            v-if="!hasClient"
                                            :key="'card-input-new'"
                                            v-async-validate:debounce="500"
                                            v-model="client.discount.card_number"
                                            :async-rules="$_rulesAs.card"
                                            placeholder="Бонусная карта"
                                            maxlength="7"
                                            solo
                                            v-mask="'#######'"
                                    />
                                    <v-text-field
                                            v-else
                                            :key="'card-input-existing'"
                                            v-model="client.discount.card_number"
                                            placeholder="Бонусная карта"
                                            maxlength="7"
                                            solo
                                            v-mask="'#######'"
                                            :disabled="hasClient"
                                    />
                                    <div class="form-check" v-if="!hasClient">
                                        <input name="agreement" type="checkbox" class="form-check-input" id="agreement"
                                               v-model="client.customer.agreement">
                                        <label class="form-check-label" for="agreement">Согласен на рассылку</label>
                                    </div>
                                    <template v-if="!hasClient">
                                        <template v-if="!queue">
                                            <div class="form-group mb-3">
                                                <v-btn v-for="i in discount" @click="setDiscount(i)" class="ml-3 mt-2"
                                                       :style="i==selectedDiscount?'background-color:#49d461':''"
                                                       :key="i">{{i}} %
                                                </v-btn>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="form-group mb-3">
                                                <v-btn class="ml-3 mt-2" style="background-color: #49d461;" :key="5">5
                                                    %
                                                </v-btn>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <div class="form-group mb-">
                                            <v-btn class="ml-3 mt-2" style="background-color: #49d461;">{{(client.discount.value + client.additional_discount.value) *100}} %</v-btn>
                                        </div>
                                    </template>
                                    <v-btn
                                            class="btn-custom pa-3 mt-4"
                                            color="light-green lighten-3"
                                            :disabled="!valid"
                                            @click.prevent="saveClient()"
                                            v-if="!hasClient"
                                    >
                                        Сохранить
                                    </v-btn>
                                    <v-btn
                                            to="/order/clientcard"
                                            color="success"
                                            v-else
                                    >
                                        Продолжить
                                    </v-btn>
                                </v-form>
                            </div>
                        </div>
                        <!--          <div class="col-md-6 offset-1"></div>-->
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex'
    import rules from './rules'


    export default {
        props: ['queue'],
        data() {
            return {
                rules: {
                    required: value => !!value || 'Поле необходимо для заполнения.',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'невалидный e-mail.'
                    },
                    counter: value => value.length <= 20 || 'Max 20 characters',
                },
                valid: false,
                selectedDiscount: 11,
                discount: [],
                name: '',
                localPhone: '',
            }
        },
        created: function () {
            this.$_rulesAs = {
                name: [rules.string({required: true})],
                phone: [rules.phoneAsync({required: true})],
                card: [rules.cardAsync({required: true})],
            };
            this.fetchDiscounts();
        },
        mounted() {
            this.$store.dispatch('login/getWorkshop');
            if (this.queue) {
                this.selectedDiscount = 5;
            }
            // this.client.customer.phone
            this.$store.commit('updateCarTypeArr', [])
            const phone = this.client.customer.phone;
            const queryPhone = this.$route?.query?.phone;

            if (phone) {
                this.getClient(phone.replace(/[^0-9.]/g, '').substr(1), 'phone')
            } else if(queryPhone) {
                this.getClient(queryPhone.replace(/[^0-9.]/g, '').substr(1), 'phone')
            }
            if (!this.client.customer.phone) {
              this.localPhone = queryPhone
            }
        },
        computed: {
            ...mapGetters(['step']),
            phoneUnMasked() {
                let val = this.localPhone ? this.localPhone : '';
                val = val.replace('+7(', '');
                val = val.replace(')', '');
                val = val.replace(' ', '');
                val = val.replace('-', '');
                val = val.replace('-', '');
                return val;
            },
            client: {
                get() {
                    return this.$store.getters.client
                },
                set(value) {
                    this.$store.commit('updateClient', value)
                }
            },
            phone() {
                return this.client.customer.phone
            },
            hasClient() {
                return this.client.discount && this.client.customer && this.client.customer.phone.length === 10 && !!this.client.discount.value
            }
        },
        watch: {
            localPhone(value) {
              console.log('')
                if  (value.length === 17) {
                    this.getClient(value.replace(/[^0-9.]/g, '').substr(1), 'phone')
                    this.client.customer.phone = value;
                } else if (this.hasClient) {
                    this.client.customer.name = '';
                    this.client.customer.surname = '';
                    this.client.discount.card_number = '';
                    this.client.discount.value = 0;
                }
            },
            hasClient(value) {
              if (value) return

                this.client.discount.card_number = null
                this.client.customer.name = null
                this.client.customer.surname = null
            },
            // phone(value, oldValue) {
            //     if (value.length > 17) {
            //         this.client.customer.phone = value.slice(0, 17)
            //     } else if (value.length === 17 && value !== oldValue && oldValue !== '') {
            //         console.log('1')
            //         this.getClient(value.replace(/[^0-9.]/g, '').substr(1), 'phone')
            //         if (!this.client.customer?.phone) {
            //             console.log(this.client.customer?.phone)
            //             this.client.customer.phone = value
            //         }
            //     }
            // },
            // client: {
            //     handler() {
            //         while (this.client.customer.phone.charAt(0) === '8' || this.client.customer.phone.charAt(0) === '7') {
            //             return this.client.customer.phone = this.client.customer.phone.substr(1);
            //         }
            //     },
            //     deep: true
            // }
        },
        methods: {
            async fetchDiscounts() {
                try {
                    const response = await this.$store.dispatch('fetchDiscounts');
                    this.discount = response.data;
                    if (this.discount.length > 0) {
                        this.selectedDiscount = this.discount[0];
                    }
                } catch (error) {
                    console.error('Error fetching discounts:', error);
                }
            },
            getClient(searchString, type) {
                this.$store.commit('resetClient')
                this.$store.commit('resetChoosenServicesComponent')
                this.$store.dispatch('fetchClient', {searchString, type})
            },
            setDiscount(i) {
                this.selectedDiscount = i
            },
            saveClient() {
                const body = {
                    name: this.client.customer.name,
                    surname: this.client.customer.surname,
                    phone: this.phoneUnMasked,
                    card_number: this.client.discount.card_number,
                    discount: this.selectedDiscount,
                    agreement: this.client.customer.agreement,
                }
                this.$store.dispatch('saveNewClient', body).then(() => {
                    this.$router.push('/order/clientcard')
                }).catch((e) => {
                    console.log('error:', e.errors)
                })
            }
        }
    }
</script>
<style scoped>
    .identity {
        height: 100%;
        min-height: 100%;
        padding: 44px 52px 63px 52px;
        position: relative;
    }

    .identity .btn-close {
        position: absolute;
        top: 53px;
        right: 52px;
    }

    .btn-custom {
        margin: 0;
        width: 259px;
        height: 56px;
        font-family: "Istok Web Regular";
        font-size: 20px;
        color: #4a4a4a;
        border: 1px solid #ced4da;
        border-radius: 11px;
        background-color: #e8ffcf;
        text-transform: none;
    }

    .input {
        font-family: "Istok Web Regular";
        background-color: #e9e9e9;
    }

    .input--middle {
        height: 56px;
        font-size: 20px;
        border-radius: 11px;
    }

    .form-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
